import {
    DashbaordTitleContainer,
    DashboardTitleIcon,
    DashboardTitleText,
} from "./DashboardTitleStyle";
import LiquiBotLogo from "../../Icons/LiquiBotLogo.png";
import { useEffect, useRef, useState } from "react";

interface DashboardTitleProps {
    parentWidth: number;
}

export const DashboardTitle: React.FC<DashboardTitleProps> = (props) => {
    const titleContainerRef = useRef<HTMLDivElement>(null);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        titleContainerRef
            ? setOffset(
                  (titleContainerRef.current
                      ? props.parentWidth -
                        titleContainerRef.current.offsetWidth
                      : 1) / 2
              )
            : setOffset(0);
    }, [props.parentWidth, titleContainerRef]);

    return (
        <DashbaordTitleContainer ref={titleContainerRef} offset={offset}>
            <DashboardTitleIcon src={LiquiBotLogo} />
            <DashboardTitleText>Liquibot</DashboardTitleText>
        </DashbaordTitleContainer>
    );
};
